import { IDeleteContasPagarUseCase } from "../../../presentation/useCases/delete/delete_contas_pagar_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * DeleteContasPagarUseCase
 */

export class DeleteContasPagarUseCase implements IDeleteContasPagarUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async deleteContasPagarByIds(idList: number[], tela: string): Promise<void> {
    await this.repository.deleteContasPagarByIds(idList, tela);

  }
}
